// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--hFy2P","dataTable":"dataTable--IpKvu","serviceLog":"serviceLog--wWM5x","title":"title--H51zr","content":"content--c6nx8"};